// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1dde6925","977":"2849b0ca"}[chunkId] + ".chunk.js";
};